/**
 * Creates a state updater function that merges partial state updates
 * @param setState - React state setter function
 * @returns Function that accepts partial state updates
 */
export function createStateUpdater<T>(
  setState: React.Dispatch<React.SetStateAction<T>>
) {
  return (updates: Partial<T>) => {
    setState((prev: T) => ({ ...prev, ...updates }));
  };
}
